import AppShell from '../../components/layouts/AppShell.jsx';
import AdminDashboard from './AdminDashboard.jsx';

// Complete package page used by consumer applications. AdminDashboard remains
// separately exported for hosts that already provide their own AppShell.
export default function AdminPageWithShell(props) {
  return (
    <AppShell>
      <AdminDashboard {...props} />
    </AppShell>
  );
}
